import { BasketballTeamGame, BasketballTeamGameCarpool } from '@hefe/models';
import { BasketballGamesSlice, ModalsSlice } from '@hefe/store';
import { Button, Col, List, Row, Spin, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React, { useState } from 'react';
import { FiTrash } from 'react-icons/fi';
import { useAppDispatch } from '../../../../../store/store';
import CustomList from '../../../../core/components/custom-list/custom-list.component';
import UserAvatar from '../../../../core/components/user/user-avatar/user-avatar/user-avatar.component';
import GameTeamCarpoolForm from '../../../forms/game-team-carpool/game-team-carpool.form';

interface GameDetailsTeamCarpoolComponentProps {
  teamDetails: BasketballTeamGame;
}

export default function GameDetailsTeamCarpoolComponent(
  props: GameDetailsTeamCarpoolComponentProps
) {
  const dispatch = useAppDispatch();
  const { carpool } = props.teamDetails;

  const [isDeleting, setDeleting] = useState(false);

  const users = [
    ...(props.teamDetails.user_coaches?.map((u) => u.id) || []),
    ...(props.teamDetails.user_players?.map((u) => u.id) || []),
  ];

  const userHasCarpool = carpool?.find((c) => users.includes(c.user_id));

  const removeCarpool = (id: number) => {
    setDeleting(true);
    dispatch(
      BasketballGamesSlice.deleteCarpoolFromGame({
        gameId: props.teamDetails.game_id,
        teamId: props.teamDetails.team_id,
        id: id,
      })
    )
      .unwrap()
      .catch(() => null)
      .finally(() => setDeleting(false));
  };

  const openForm = () => {
    dispatch(
      ModalsSlice.modalsActions.openModal({
        title: t('carpool'),
        component: <GameTeamCarpoolForm teamDetails={props.teamDetails} />,
        formId: 'event-team-carpool',
      })
    );
  };

  const renderAddButton = () => {
    if (!userHasCarpool) {
      return (
        <Col>
          <Button onClick={() => openForm()}>+</Button>
        </Col>
      );
    }

    return null;
  };

  const renderStatus = () => {
    const numberOfPlayers = props.teamDetails.team?.playerReplies?.yes.length;
    let numberOfSeats =
      carpool
        ?.map((c) => c.number_of_seats)
        .reduce((partialSum, a) => partialSum + a, 0) || 0;
    numberOfSeats += props.teamDetails.car?.seats || 0;

    return (
      <Typography.Text>
        {numberOfPlayers} {t('players')} | {numberOfSeats}{' '}
        {t('seats_available')}
      </Typography.Text>
    );
  };

  const renderListItem = (item: BasketballTeamGameCarpool) => {
    const actions: any[] = [];
    if (userHasCarpool) {
      actions.push(
        isDeleting ? (
          <Spin size="small" />
        ) : (
          <FiTrash
            key={1}
            onClick={() => removeCarpool(item.id)}
            style={{ cursor: 'pointer' }}
            size={16}
          />
        )
      );
    }
    return (
      <List.Item key={item.id} actions={actions}>
        <List.Item.Meta
          avatar={
            item.user ? <UserAvatar user={item.user} size="default" /> : null
          }
          title={`${item.user?.firstname} ${item.user?.lastname}`}
          description={`${item.number_of_seats} ${t('seats')} ${
            item.note ? '| ' + item.note : ''
          }`}
        />
      </List.Item>
    );
  };

  return (
    <div>
      <Row justify="space-between" align="middle">
        <Col>{renderStatus()}</Col>
        {renderAddButton()}
      </Row>
      <Row>
        <Col xs={24}>
          <CustomList
            itemLayout="horizontal"
            dataSource={carpool}
            renderItem={(item: BasketballTeamGameCarpool) =>
              renderListItem(item)
            }
          />
        </Col>
      </Row>
    </div>
  );
}
